import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';
import { OperationType } from 'src/app/shared/interfaces/operation-type.enum';

export type OperationTypeBadgeTone = 'info' | 'success' | 'danger' | 'warning' | 'default';

export interface OperationTypeBadge {
  label: string;
  icon: string;
  tone: OperationTypeBadgeTone;
}

export const ACX_DEPOSIT_CERTIFIER_CODES = new Set(['verra', 'goldstandard']);

export function isAcxDepositOperation(operation: CarbonOperation): boolean {
  return (
    operation.rawTypeCode === OperationType.DEPOSIT &&
    ACX_DEPOSIT_CERTIFIER_CODES.has(operation.certifierCode?.toLowerCase() ?? '')
  );
}

export function getDepositSourceLabel(operation: CarbonOperation): 'ACX' | 'B3' {
  return isAcxDepositOperation(operation) ? 'ACX' : 'B3';
}

export function resolveOperationTypeBadge(operation: CarbonOperation): OperationTypeBadge {
  const rawType = operation.rawTypeCode ?? '';

  // B3: aposentadoria não é tipo de operação — é motivo de Retirada (retirementCode A).
  if (rawType === OperationType.WITHDRAW) {
    return {
      label: 'Retirada',
      icon: 'logout',
      tone: 'warning',
    };
  }

  switch (rawType) {
    case OperationType.DEPOSIT:
      return {
        label: 'Depósito',
        icon: 'check_circle',
        tone: 'success',
      };
    case OperationType.TRANSFER_WITHOUT_FINANCIAL:
      return {
        label: 'Transferência',
        icon: 'swap_horiz',
        tone: 'warning',
      };
    case OperationType.TRADE_TO:
      return {
        label: 'Compra - ACX',
        icon: 'currency_exchange',
        tone: 'info',
      };
    case OperationType.TRADE_FROM:
      return {
        label: 'Venda - ACX',
        icon: 'currency_exchange',
        tone: 'info',
      };
    case OperationType.RETIREMENT:
      return {
        label: 'Aposentadoria - ACX',
        icon: 'check_circle',
        tone: 'info',
      };
    case OperationType.DELIVERY:
      return {
        label: 'Retirada - ACX',
        icon: 'logout',
        tone: 'info',
      };
    default:
      return {
        label: operation.typeCode || '-',
        icon: 'info',
        tone: 'default',
      };
  }
}
